import { BookmarkedArticleResponse, GetArticlesByIdArrayResponse as Article } from 'articles/types/Article';
import { get, getWp, post } from '../../common/ApiClient';
type ArticleField = keyof Article;

export const getBookmarkedArticleIds = async (): Promise<BookmarkedArticleResponse> => {
  const { data } = await get<BookmarkedArticleResponse>('/user/bookmarks', true);

  return data;
};

export const getArticleById = async (id: string, fields: ArticleField[] = []): Promise<Article> => {
  const url = `/posts/?include=${encodeURIComponent(id)}&_fields=${encodeURIComponent(fields.join(','))}`;
  return getWp<Article[]>(url).then(({ data: [article] }) => article);
};

export const getArticlesByIdArray = (ids: string[], fields: ArticleField[] = []): Promise<Article[]> =>
  Promise.all(ids.map((id) => getArticleById(id, fields)));

export const removeBookmarkedArticle = async (id: string): Promise<any> => {
  const idArr = id.split(',').map(Number);

  let formData = new FormData();
  formData.append('crm_action', 'remove');
  formData.append('posts', JSON.stringify(idArr));

  const { data } = await post<void>('/user/bookmarks-manager', true, formData);

  return data;
};

export const addBookmarkedArticle = async (id: string): Promise<any> => {
  const idArr = id.split(',').map(Number);

  let formData = new FormData();
  formData.append('crm_action', 'add');
  formData.append('posts', JSON.stringify(idArr));

  const { data } = await post<void>('/user/bookmarks-manager', true, formData);

  return data;
};
